import { render, staticRenderFns } from "./add-category.vue?vue&type=template&id=44f3cd06&scoped=true"
import script from "./add-category.vue?vue&type=script&lang=js"
export * from "./add-category.vue?vue&type=script&lang=js"
import style0 from "./add-category.vue?vue&type=style&index=0&id=44f3cd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f3cd06",
  null
  
)

export default component.exports